import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../store";

// react-redux 9 + RTK 2: typed-call style. The `withTypes` helper
// theoretically does the same job but didn't fully thread RTK 2's
// `ThunkDispatch & Dispatch` intersection through to call sites for
// us, so dispatching a thunk lost its overload. The generic-call form
// preserves both call signatures (plain action + thunk) intact.
export const useCustomDispatch = () => useDispatch<AppDispatch>();
export const useCustomSelector = useSelector.withTypes<RootState>();
